"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingFontWeight = exports.RatingFontSizeOptions = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Star_1 = __importStar(require("../Icons/Star/Star"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var RatingFontSizeOptions;
(function (RatingFontSizeOptions) {
    RatingFontSizeOptions["default"] = "default";
    RatingFontSizeOptions["xSmall"] = "xSmall";
    RatingFontSizeOptions["small"] = "small";
    RatingFontSizeOptions["large"] = "large";
    RatingFontSizeOptions["xLarge"] = "xLarge";
})(RatingFontSizeOptions = exports.RatingFontSizeOptions || (exports.RatingFontSizeOptions = {}));
var RatingFontWeight;
(function (RatingFontWeight) {
    RatingFontWeight["default"] = "default";
    RatingFontWeight["medium"] = "medium";
    RatingFontWeight["bold"] = "bold";
})(RatingFontWeight = exports.RatingFontWeight || (exports.RatingFontWeight = {}));
var StarRatingGroupElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 0.2rem;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 0.2rem;\n"])));
var RatingCountElement = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  padding-left: ", ";\n  ", ";\n  font-family: ", ";\n  ", "\n"], ["\n  margin: 0;\n  padding-left: ", ";\n  ", ";\n  font-family: ", ";\n  ", "\n"])), function (_a) {
    var spacing = _a.spacing;
    switch (spacing) {
        case Star_1.IconSpacingSizes.small:
            return '0.4rem';
        case Star_1.IconSpacingSizes.medium:
            return '0.6rem';
        case Star_1.IconSpacingSizes.large:
            return '0.8rem';
        default:
            return '0';
    }
}, function (_a) {
    var size = _a.size;
    if (size === b2c_theme_1.IconSizes.xSmall) {
        return "\n        margin-top: 0.4rem;\n        font-size: 1.2rem;\n      ";
    }
    else if (size === b2c_theme_1.IconSizes.small) {
        return "\n        margin-top: 0.5rem;\n        font-size: 1.4rem;\n      ";
    }
    else if (size === b2c_theme_1.IconSizes.large) {
        return "\n        margin-top: 1rem;\n        font-size: 1.8rem;\n      ";
    }
    return "\n        margin-top: 0.5rem;\n        font-size: 1.6rem\n      ";
}, function (_a) {
    var fontWeight = _a.fontWeight;
    switch (fontWeight) {
        case RatingFontWeight.bold:
            return b2c_theme_1.fonts.defaultBold;
        case RatingFontWeight.medium:
            return b2c_theme_1.fonts.defaultMedium;
        default:
            return b2c_theme_1.fonts.default;
    }
}, function (props) {
    switch (props.fontSize) {
        case 'xSmall':
            return 'font-size: 1.2rem;';
        case 'small':
            return 'font-size: 1.4rem;';
        case 'large':
            return 'font-size: 1.6rem;';
        case 'xLarge':
            return 'font-size: 1.8rem;';
        default:
            return;
    }
});
var Separator = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0 0.4rem;\n  font-size: ", ";\n"], ["\n  margin: 0 0.4rem;\n  font-size: ", ";\n"])), function (_a) {
    var size = _a.size;
    switch (size) {
        case b2c_theme_1.IconSizes.xSmall:
            return '1.4rem';
        case b2c_theme_1.IconSizes.small:
            return '1.8rem';
        case b2c_theme_1.IconSizes.large:
            return '6rem';
        default:
            return '2.2rem';
    }
});
var StarRatingGroup = function (props) {
    var defaultProps = {
        activeStars: 0,
        fontWeight: RatingFontWeight.default,
        iconSize: b2c_theme_1.IconSizes.medium,
        iconSpacing: Star_1.IconSpacingSizes.medium,
        includeRatingCount: false,
        totalStars: 5,
    };
    var _a = __assign(__assign({}, defaultProps), props), activeStars = _a.activeStars, fontSize = _a.fontSize, fontWeight = _a.fontWeight, iconSize = _a.iconSize, iconSpacing = _a.iconSpacing, includeRatingCount = _a.includeRatingCount, ratingCount = _a.ratingCount, totalStars = _a.totalStars, includeSeparator = _a.includeSeparator, rest = __rest(_a, ["activeStars", "fontSize", "fontWeight", "iconSize", "iconSpacing", "includeRatingCount", "ratingCount", "totalStars", "includeSeparator"]);
    var stars = [];
    for (var i = 0; i < totalStars; i++) {
        stars.push(react_1.default.createElement(Star_1.default, { key: "".concat(i, "/").concat(activeStars - 1), size: iconSize, color: i <= activeStars - 1 ? Star_1.IconColorThemes.primary : Star_1.IconColorThemes.faded, spacing: iconSpacing, "data-isactive": i <= activeStars - 1 }));
    }
    return (react_1.default.createElement(StarRatingGroupElement, __assign({ "data-testid": "star-rating-group" }, rest),
        stars,
        includeRatingCount ? (react_1.default.createElement(react_1.default.Fragment, null,
            includeSeparator && (react_1.default.createElement(Separator, { "data-testid": "star-rating-separator", size: iconSize }, "|")),
            react_1.default.createElement(RatingCountElement, { fontSize: fontSize, fontWeight: fontWeight, size: iconSize, spacing: iconSpacing, "data-testid": "star-rating-group-count" }, "".concat(ratingCount)))) : null));
};
exports.default = StarRatingGroup;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=StarRatingGroup.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/StarRatingGroup/StarRatingGroup.js
// module id = 480
// module chunks = 81